import { AdminButton } from '@website/components/admin/AdminButton';
import { AdminFeature } from '@website/components/admin/AdminFeature';
import Avatar from '@website/components/directoryTheme/Avatar';
import Stars from '@website/components/directoryTheme/Stars';
import { ReplyToReview } from '@website/components/hosts/dashboard/reviews/admin/ReplyToReview';
import ShowReply from '@website/components/trips/TripsPage/reviews/ShowReply';
import Truncate from '@website/components/utilities/Truncate';
import { HostReviewsQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { DeleteReview } from './admin/DeleteReview';
import { RemoveReplyFromReview } from './admin/RemoveReplyFromReview';

type Props = {
  review: HostReviewsQuery['hostByURL']['reviews']['items'][0];
  host: Pick<HostReviewsQuery['hostByURL'], 'id' | 'name'>;
};

export default function HostReviewCard({ review, host }: Props) {
  return (
    <div className="review">
      <div className="d-flex d-block d-sm-flex">
        <div className="text-md-center me-4 me-xl-5">
          <Avatar
            size="xl"
            image={review?.user?.picture?.file?.key}
            defaultImageText={review.user?.givenName}
            border
            alt={`${review.user?.givenName}`}
          />
        </div>
        <div>
          <h6 className="mt-2 mb-0">{review.user?.givenName}</h6>
          <div className="mb-2">
            <Stars
              size="xs"
              color="text-primary"
              stars={review.fiveStarRating}
            />
            <p className="text-uppercase text-sm text-muted">
              <Link
                href={`/trips/${review.trip.urlSlug}`}
                passHref
                className="text-uppercase text-sm fw-bold text-muted"
              >
                {review.trip.title}
              </Link>{' '}
              - Traveled{' '}
              {DateTime.fromISO(review.startDate).toFormat('MMM yyyy')}
            </p>
          </div>

          <Truncate lines={3} enableExpand className="text-muted text-sm">
            {review.body}
          </Truncate>
          <ShowReply review={review} host={host} />
        </div>
      </div>
      <AdminFeature>
        <div className="d-flex justify-content-end">
          <Link href={`/me/${review.user.id}/reviews/${review.id}`}>
            <AdminButton className="mx-1" variant="danger">
              Edit Review
            </AdminButton>
          </Link>
          <ReplyToReview review={review} />
          <RemoveReplyFromReview review={review} />
          <DeleteReview review={review} />
        </div>
      </AdminFeature>
    </div>
  );
}
